<template>
  <div class="portlet-body form">
      <div class="form-group has-success">
          <label for="name" v-if="title != ''">{{ title }}:</label>
          <ckeditor :editor="editor" v-model="content" :config="editorConfig" @input="handleInput"></ckeditor>
          <p class="text-center alert alert-danger" v-if="errors[name]">{{ errors[name][0] }}</p>
      </div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


export default {

  name: 'vCkeditor',
  props: {
    type: {
        default: 'text'
    },
    name:{
        default: ''
    },
    title: {
        default: ''
    },
    value: {
        default: ''
    },
    unit: {
        default: ''
    },
  },
  data () {
    return {
            content: this.value === null ? '' : this.value,
            editor: ClassicEditor,
            editorConfig: {
                removePlugins: [ 'Heading'],
                toolbar: [ 'bold', 'italic', 'bulletedList', 'numberedList', 'blockQuote', 'link' ],
                language: 'fr',
                columns: '20'
            },
            errors: {}
        }   
    },
    mounted() {
        this.$emit('input', this.value === null ? '' : this.value)
        Event.listen('errors', (e) => {
            this.errors = e
        })
    },
    watch: {
      value: function(newVal, oldVal) {
        this.content = newVal
      }
    },
    methods: {
        handleInput (e) {
            this.$delete(this.errors, this.name)
            this.$emit('input', this.content)
        }
    }
};
</script>

<style lang="css" scoped>
</style>
